export default "__VITE_ASSET__bb72727f__"